export const FbPixel = {
  pageview() {
    window.fbq('track', 'PageView');
  },
  event(name, options = {}) {
    window.fbq('track', name, options);
  },
};
